<div class="rs-entrypoint-container">
  <ng-container
    *ngFor="
      let category of division.summaryCategories | keyvalue : unsorted;
      last as last
    "
  >
    <a
      (click)="
    categoryClick.emit({division, amount: category.value, category: category.key})
    "
      data-tms-event="link-click"
      data-tms-link-zone="mybill.detail"
      [attr.data-tms-link-name]="
        getItemTitle(category.identifier, category.key, division.type)
      "
      [attr.data-cy]="
        'myBillCoverDivisionLink:' +
        getItemTitle(category.identifier, category.key, division.type)
      "
      class="rs-entrypoint"
    >
      <span class="rs-entrypoint-title">{{
        getItemTitle(category.identifier, category.key, division.type)
      }}</span>
      <span class="rs-entrypoints-extra" data-cy="myBillCoverDivisionAmount">
        <strong>
          <px-currency-amount [amount]="category.value"></px-currency-amount
        ></strong>
      </span>
      <span class="rs-entrypoint-arrow" aria-hidden="true"></span>
    </a>
  </ng-container>
</div>
